import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { IoClose, IoMenu } from "react-icons/io5";
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { styled } from "@mui/material";
import myImage from 'C:/Users/bswarnka/Downloads/log.png';
import logo from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/GrayLogojpg.jpg';

const pages = ['Home','About', 'Services', 'Blog', 'Contact Us'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const Logo = styled('img')({
  height: '60px', // Customize the height
  width: '80px',
  marginRight: '10px', // Spacing between logo and title
  marginTop: '6px'
});

const LogoMobile = styled('img')({
  height: '50px', // Customize the height
  width: '70px',
  marginRight: '10px', // Spacing between logo and title
  marginTop: '10px'
});

const TopBar = () => {
  return (
    <Box sx={{ backgroundColor: '#4FC3F7', padding: '10px'}}>
      <Typography variant="body1" align="center">
      <a href ="tel:+91-90328-21700" style={{ textDecoration:"none"}}> +91-90328-21700 </a>
      / Plot, No: 320, Rd No 7, Kakatiya Hills, Madhapur 
      </Typography>
    </Box>
  );
};

export default function Navbar () {

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
    console.log(event);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
    console.log(event);
  };

  const handleCloseNavMenu = (event) => {
    setAnchorElNav(null);
    console.log(event);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };



 return (
  <>
  <TopBar position="fixex"/>
<AppBar position="relative" style={{background:'#21252B', height:70}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
        
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <Logo src={logo}/>
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography sx={{ textAlign: 'center', textTransform: 'none' }}>
                  <Link
                      to={`/${page === 'Home' ? '' : page === 'Contact Us'? 'ContactUs': page}`}
                      style={{ textDecoration: 'none', color: '#21252B' }}
                    >
                      {page}
                    </Link>
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <LogoMobile src={logo}/>
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block', textTransform: 'none' }}
              >
               <Link
                  to={`/${page === 'Home' ? '' : page === 'Contact Us'? 'ContactUs': page}`}
                  style={{ textDecoration: 'none', color: '#FFFFFF' }}
                >
                  {page}
                </Link>
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
    </>
 );
};
